(() => {
  const root = document.querySelector('[data-parallax-banner]');
  if (!root) return;

  const slides = Array.from(root.querySelectorAll('[data-slide]'));
  const previews = Array.from(root.querySelectorAll('[data-preview]'));
  const frame = root.querySelector('.parallax-banner__preview-frame');
  const texts = Array.from(root.querySelectorAll('[data-text]')); // if you have sticky text items

  if (!slides.length || !previews.length || !frame) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  let ticking = false;

  const setStickyTop = () => {
    const vv = window.visualViewport;
    const vvh = vv ? vv.height : window.innerHeight;
    const vTop = vv ? vv.offsetTop : 0;
    const frameH = frame.getBoundingClientRect().height;

    if (window.innerWidth < 760) {
      root.style.setProperty("--stickyTop", "32px");
    } else {
      const header = document.querySelector("header");
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      root.style.setProperty("--stickyTop", `${headerHeight + 56}px`);
    }
  };

  const update = () => {
    ticking = false;

    const frameRect = frame.getBoundingClientRect();
    const frameBottom = frameRect.bottom;
    const frameH = frameRect.height;

    // Active slide index (for text swap)
    const vv = window.visualViewport;
    const vvh = vv ? vv.height : window.innerHeight;
    const mid = vvh * 0.5;

    let activeIdx = 0;
    for (let i = 0; i < slides.length; i++) {
      const r = slides[i].getBoundingClientRect();
      if (r.top <= mid) activeIdx = i;
    }

    // Toggle fixed text (if you’re using it)
    if (texts.length) {
      texts.forEach((t, i) => t.classList.toggle('is-active', i === activeIdx));
    }

    // First preview always visible
    if (previews[0]) {
      previews[0].style.setProperty('--clipPx', '0px');
      previews[0].style.zIndex = '1';
    }

    // Pixel-locked reveal for others
    for (let i = 1; i < slides.length; i++) {
      const slideTop = slides[i].getBoundingClientRect().top;
      const revealPx = clamp(frameBottom - slideTop, 0, frameH);
      const clipTopPx = frameH - revealPx;

      previews[i].style.setProperty('--clipPx', `${clipTopPx}px`);
      previews[i].style.zIndex = String(i + 1);
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    setStickyTop();
    update();
  });

  // iOS/Android browser chrome show/hide triggers visualViewport resize
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
      setStickyTop();
      update();
    });
    window.visualViewport.addEventListener('scroll', onScroll, { passive: true });
  }

  setStickyTop();
  update();
})();
